import Vue from 'vue';
export default {
  data() {
    return {
      searchTitle: '',
      ambulance800ListTableHeader: [
        {
          text: 'ردیف',
          value: 'row',
          align: 'center',
          width: '20px',
          sortable: false,
        },
        {
          text: 'وضعیت',
          value: 'icon',
          align: 'center',
          width: '20px',
          sortable: false,
        },
        {
          text: 'کد گوشی',
          value: 'phoneCode',
          align: 'center',
          isGroupable: true,
        },
        { text: 'نوع کد', value: 'codeType', align: 'center' },
        { text: 'تعداد ماموریت', value: 'missionCount', align: 'center' },
        {
          text: 'تاریخ ورود',
          value: 'loginDate',
          align: 'center',
          isGroupable: true,
        },
        { text: 'ناحیه', value: 'zone', align: 'center', isGroupable: true },
        {
          text: 'کد شبرنگ',
          value: 'shabrangCode',
          align: 'center',
          isGroupable: true,
        },
        { text: 'کاربر ارشد', value: 'seniorUser', align: 'center' },
        { text: 'کاربر اول', value: 'firstUser', align: 'center' },
        { text: 'توضیحات ', value: 'note', align: 'center' },
        { text: 'شماره تماس ', value: 'phoneNumber', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      listOfCodesFor800AmbulanceList: [],
      missionPhoneCode: '',
      moreInfoModel: false,
      moreInfoData: [],
    };
  },
  methods: {
    showMoreDataModel: function (item) {
      this.missionPhoneCode = item.phoneCode;
      this.getListOfUsersPhoneActivityReport(item.id);
      this.moreInfoModel = true;
    },
    closeMoreInfoModal: function () {
      this.moreInfoModel = false;
    },
    makeReadyMoreInfoData: function (data) {
      this.moreInfoData = [];
      for (let i = 0; i < data.length; i++) {
        let loginDate = '';
        let logoutDate = '';
        let user = '';
        if (data[i].loginDate) {
          loginDate = Vue.moment(data[i].loginDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        if (data[i].logoutDate) {
          logoutDate = Vue.moment(data[i].logoutDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        if (data[i].userAccount) {
          let fName = data[i].userAccount.firstName;
          let lName = data[i].userAccount.lastName;
          user = fName + ' ' + lName;
        }
        this.moreInfoData.push({
          status: data[i].isActive,
          id: data[i].id,
          info: [
            {
              title: 'نام و نام خانوادگی',
              value: user,
              icon: 'mdi-account mdi-18px',
              size: 3,
            },
            {
              title: 'شماره تماس',
              value: data[i].userAccount ? data[i].userAccount.phoneNumber : '-',
              icon: 'mdi-phone mdi-flip-h mdi-18px',
              size: 3,
            },
            {
              title: 'زمان ورود',
              value: loginDate,
              icon: 'mdi-clock-time-four mdi-18px',
              size: 3,
            },
            {
              title: 'زمان خروج',
              value: logoutDate,
              icon: 'mdi-clock-time-four mdi-18px',
              size: 3,
            },
          ],
        });
      }
    },
    callToCode: function (number) {
      if (number) {
        let data = {
          missionId: this.missionId,
          missionPhoneId: this.missionPhoneId,
          to: number,
        };
        this.callToCodeFunction(data);
      }
    },
  },
};
